var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 36.75C7.7875 36.75 6.96383 36.4076 6.279 35.7227C5.59417 35.0379 5.25117 34.2137 5.25 33.25V8.75C5.25 7.7875 5.593 6.96383 6.279 6.279C6.965 5.59417 7.78867 5.25117 8.75 5.25H21V8.75H8.75V33.25H21V36.75H8.75ZM28 29.75L25.5938 27.2125L30.0562 22.75H15.75V19.25H30.0562L25.5938 14.7875L28 12.25L36.75 21L28 29.75Z",
    fill: "#845BB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.04681900133dea8430470a9cb3510109.svg";
export { ForwardRef as ReactComponent };